import { useContext, useState, Fragment } from 'react';
import AuthContext from '../../context/autenticacion/authContext'
import clienteAxios from '../../config/axios';
import { useT } from 'i18n';

 
 

 
 

import Mensaje from 'components/Alertas/Mensaje';
import LineSpinner from 'components/spinners/LineSpinner'



const WindowsDatos = ({setCompletar}) => {
    const { t, ts } = useT();


    const authContext = useContext(AuthContext);
    const {jimf_theme, usuario} = authContext;


    const [ spin, setSpin ] = useState(false);

                    const [mensaje, guardarMensaje] = useState('')

                    // const { message } = mensaje;  

                    const [mensajeopen, guardarMensajeOpen] = useState(false);

                    const Cerrar = () => {
                        setCompletar(false)
                      }

  

    const Loader = ( spin ) ? <LineSpinner/> :  
                                          
    <Fragment>
      {t('cuenta.actualizarInfo')}
      </Fragment> 



const [profilechange, guardarProfileChange] = useState(usuario); 


    // const [profilechange, guardarProfileChange] = useState({
    //     id: '',
    //     name:'',
    //     email:'',
    //     client_type:'',
    //     identity:'',
    //     birthday_date:'',
    //     total_rent:'',
    //     status:'',
    //     profession_id:'',
    //     user_id:'',
    //     telephone:'',
    //     representative_name:'',
    //     representative_cpf:'',
    //     company_activity:'',
    //     created_at:'',
    //     updated_at:'',
    //     address_street:'',
    //     address_number:'',
    //     address_city:'',
    //     address_zipcode:'',
    //     address_zone:'',
    //     address_country:'',
    //     is_ofertante:'',
    //     comercial_name:'',
    //     referido:'',
    //     cpf_no_activo:'',
    //     cpf:'',
    //     first_name:'',
    //     last_name:'',
    //     middle_name:'',
   
    // }); 



    const {id,
        name,email,referrer,client_type,identity,
        birthday_date,total_rent,status,
        profession_id,user_id,telephone,
        representative_name,representative_cpf,
        company_activity,created_at,updated_at,
        address_street,address_number,address_city,
        address_zipcode,address_zone,address_country,is_ofertante,
        comercial_name,referido,cpf_no_activo,
        cpf,first_name,last_name,middle_name,direccion_cliente,
        sexo,situacionlaboral,ocupacion,lugartrabajo
        
          
          } = profilechange; 



          const consultarApiUpdate = async () => {


            try {
                const respuesta = await clienteAxios.post('/api/client/update',profilechange)
                    guardarMensaje(ts(respuesta.data.message));
                        guardarMensajeOpen(true);
                        setSpin(false);
                        
        //   setTimeout(() => {
                //   setRecargarData(true);
                //   guardarCargando(false);
                //   guardarEnviarDepositoBtn(false);
                    // handleOpen(); 
        } catch (error) {
            guardarMensajeOpen(true)
            guardarMensaje(ts(error.response.data.message));
            setSpin(false)
            
                    // handleOpen();
                  
        }
    
           
    
          
        //     guardarMensaje(null);
        //     guardarCargando(false);
        // },6000);
          
          
        } 


        const onChange = e => {
      
              // voy a colocar guardar usuario en el state
      
              guardarProfileChange({
                  ...profilechange,
                  [e.target.name] : e.target.value
      
              })
          }
      
          
    

    
    const onSubmit = e => {
        e.preventDefault();
        setSpin(true);

        consultarApiUpdate({
            name,
            comercial_name,
            email,
            
            identity,
            birthday_date,
            telephone,
            address_street,
            address_number,
            address_zipcode,
            address_city,
            sexo,
            situacionlaboral,
            ocupacion,
            lugartrabajo
        });


    } 





    return (  

        <>
        

        <div className="form-data-complete">

            <div className="back-btn-jimf">
                <button
                    onClick={Cerrar}
                >{'<'}</button>


            </div>




            <form  onSubmit={onSubmit} >

                <div className="tittle-box">

                <h2>{t('cuenta.actualizacionTitulo')}</h2>
                <h3>www<strong>.panther7.</strong>com</h3>


                </div>


                

                <div className="box-data-complete">



                <div className="input-size-jimf">
                    <label>{t('cuenta.fSituacion')}</label>

                    <input
                    
                    type="text"
                    id="situacionlaboral"
                    name="situacionlaboral"
                    onChange={onChange}
                    value={profilechange.situacionlaboral}
                    placeholder={ !usuario.situacionlaboral ?
                        t('cuenta.sinAgregar') 
                         : usuario.situacionlaboral
                        } 
                    />
                </div>                


                <div className="input-size-jimf">
                    <label>{t('cuenta.fEmpresa')}</label>

                    <input
                    
                    type="text"
                    id="comercial_name"
                    name="comercial_name"
                    onChange={onChange}
                    value={profilechange.comercial_name}
                    placeholder={ !usuario.comercial_name ?
                        t('cuenta.sinAgregar') 
                         : usuario.comercial_name
                        } 
                    />
                </div>

                

                <div className="input-size-jimf">
                    <label>{t('cuenta.fOcupacion')}</label>

                    <input
                    
                    type="text"
                    id="ocupacion"
                    name="ocupacion"
                    onChange={onChange}
                    value={profilechange.ocupacion}
                    placeholder={ !usuario.ocupacion ?
                        t('cuenta.sinAgregar') 
                         : usuario.ocupacion
                        } 
                    />
                </div>

                <div className="input-size-jimf">
                    <label>{t('cuenta.fNombreApellido')}</label>

                    <input
                    
                    type="text"
                    id="name"
                    name="name"
                    onChange={onChange}
                    value={profilechange.name}
                    placeholder={ !usuario.name ?
                        t('cuenta.sinAgregar') 
                         : usuario.name
                        } 

                    />
                </div>

                
                <div className="input-size-jimf">
                    <label>{t('cuenta.fDocumento')}</label>

                    <input                    
                    type="text"
                    id="identity"
                    name="identity"
                    onChange={onChange}
                    value={profilechange.identity}
                    placeholder={ !usuario.identity ?
                        t('cuenta.sinAgregar') 
                         : usuario.identity
                        } 
                    />
                </div>

                
                <div className="input-size-jimf">
                    <label>{t('cuenta.fNacimiento')}</label>

                    <input
                    type="date"
                    id="birthday_date"
                    name="birthday_date"
                    onChange={onChange}
                    value={profilechange.birthday_date}
                    placeholder={ !usuario.birthday_date ?
                        t('cuenta.sinAgregar') 
                         : usuario.birthday_date
                        } 
                    />
                </div>


                <div className="input-size-jimf">
                    <label>{t('cuenta.fSexo')}</label>

                    <input
                    
                    type="text"
                    id="sexo"
                    name="sexo"
                    onChange={onChange}
                    value={profilechange.sexo}
                    placeholder={ !usuario.sexo ?
                        t('cuenta.sinAgregar') 
                         : usuario.sexo
                        } 
                    />
                </div>

                <div className="input-size-jimf">
                    <label>{t('cuenta.fEstadoCivil')}</label>

                    <input
                    
                    type="text"
                    id="estadocivil"
                    name="estadocivil"
                    onChange={onChange}
                    value={profilechange.estadocivil}
                    placeholder={ !usuario.estadocivil ?
                        t('cuenta.sinAgregar') 
                         : usuario.estadocivil
                        } 
                    />
                </div>

                <div className="input-size-jimf">
                    <label>{t('cuenta.fPais')}</label>

                    <input
                    
                    type="text"
                    id="address_country"
                    name="address_country"
                    onChange={onChange}
                    value={profilechange.address_country}
                    placeholder={ !usuario.address_country ?
                        t('cuenta.sinAgregar') 
                         : usuario.address_country
                        } 
                    />
                </div>

                <div className="input-size-jimf">
                    <label>{t('cuenta.fProvincia')}</label>

                    <input
                    
                    type="text"
                    id="address_zone"
                    name="address_zone"
                    onChange={onChange}
                    value={profilechange.address_zone}
                    placeholder={ !usuario.address_zone ?
                        t('cuenta.sinAgregar') 
                         : usuario.address_zone
                        } 
                    />
                </div>


                <div className="input-size-jimf">
                    <label>{t('cuenta.fCiudad')}</label>

                    <input
                    
                    type="text"
                    id="address_city"
                    name="address_city"
                    onChange={onChange}
                    value={profilechange.address_city}
                    placeholder={ !usuario.address_citye ?
                        t('cuenta.sinAgregar') 
                         : usuario.address_city
                        } 
                    />
                </div>



                <div className="input-size-jimf">
                    <label>{t('cuenta.fDireccion')}</label>

                    <input
                    
                    type="text"
                    id="address_street"
                    name="address_street"
                    onChange={onChange}
                    value={profilechange.address_street}
                    placeholder={ !usuario.address_street ?
                        t('cuenta.sinAgregar') 
                         : usuario.address_street
                        } 
                    />
                </div>

                <div className="input-size-jimf">
                    <label>{t('cuenta.fDireccionCompl')}</label>

                    <input
                    
                    type="text"
                    id="address_number"
                    name="address_number"
                    onChange={onChange}
                    value={profilechange.address_number}
                    placeholder={ !usuario.address_number ?
                        t('cuenta.sinAgregar') 
                         : usuario.address_number
                        } 
                    />
                </div>

                <div className="input-size-jimf">
                    <label>{t('cuenta.fPostal')}</label>

                    <input
                    
                    type="text"
                    id="address_zipcode"
                    name="address_zipcode"
                    onChange={onChange}
                    value={profilechange.address_zipcode}
                    placeholder={ !usuario.address_zipcode ?
                        t('cuenta.sinAgregar') 
                         : usuario.address_zipcode
                        } 
                    />
                </div>



                </div>


                <div className="box-panther7">

                <button  type="submit" className={`submit-jimf ${spin === true ? 'padd-mad' :''}`}>
                                        {Loader}
                    </button>

                </div>



                    


               


                

            </form>





                <div className={`${jimf_theme === "white" ? 'ultradepositowhite':'ultradeposito' }`}>

                <div className={`${jimf_theme === "white" ? 'ultradeposito-son-white':'ultradeposito-son' }`}>
                </div>

                </div>

        </div>

                {mensajeopen ? <> 
                    <Mensaje
                            open={true}
                            mensaje={mensaje} 
                            guardarMensajeOpen={guardarMensajeOpen}
                            guardarMensaje={guardarMensaje}
                        /> 
                    

                </> : null

                }

</>



    );
}
 
export default WindowsDatos;